<template>
  <span
    class="badge-ui"
    :class="typeClass"
  >
    <slot>{{ text }}</slot>
  </span>
</template>

<script>
export default {
  name: 'BadgeUi',
  props: {
    text: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    typeClass () {
      const type = this.type.replace(/[^a-z0-9-]/gi, '').toLowerCase()
      return type ? `badge-ui--${type}` : 'badge-ui--default'
    }
  }
}
</script>

<style lang="scss" scoped>
.badge-ui {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 45px;
  height: 22px;
  padding: 2px 6px;
  border-radius: 30px;
  opacity: 1;
  background-color: #FF2F00;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
  box-sizing: border-box;

  &--default {
    background-color: #fff;
    color: #fff;
  }

  &--primary {
    background-color: #FF2F00;
    color: #fff;
  }

  &--success {
    background-color: #00a046;
    color: #fff;
  }

  &--warning {
    background-color: #ffcc00;
    color: #fff;
  }

  &--danger {
    background-color: #d91f11;
    color: #fff;
  }

  &--info {
    background-color: #4e93d9;
    color: #fff;
  }
}
</style>
